const textDefaults = {
	'EN': {
		'nameLabel': 'Name',
		'emailLabel': 'Email',
		'phoneLabel': 'Phone',
		'namePlaceholder': 'Enter full name',
		'emailPlaceholder': 'Enter email address',
		'invalidEmailText': 'Please enter a valid email address',
	},
	'FR': {
		'nameLabel': 'Nom',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Téléphone',
		'namePlaceholder': 'Entrez le nom complet',
		'emailPlaceholder': 'Entrez l\'adresse e-mail',
		'invalidEmailText': 'Veuillez entrer une adresse e-mail valide',
	},
	'NL': {
		'nameLabel': 'Naam',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefoon',
		'namePlaceholder': 'Voer volledige naam in',
		'emailPlaceholder': 'Voer e-mailadres in',
		'invalidEmailText': 'Voer een geldig e-mailadres in',
	},
	'DE': {
		'nameLabel': 'Name',
		'emailLabel': 'E-Mail',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Vollständigen Namen eingeben',
		'emailPlaceholder': 'E-Mail-Adresse eingeben',
		'invalidEmailText': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
	},
	'PL': {
		'nameLabel': 'Imię i nazwisko',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Wprowadź pełne imię i nazwisko',
		'emailPlaceholder': 'Wprowadź adres e-mail',
		'invalidEmailText': 'Proszę wprowadzić prawidłowy adres e-mail',
	},
	'BG': {
		'nameLabel': 'Име',
		'emailLabel': 'Имейл',
		'phoneLabel': 'Телефон',
		'namePlaceholder': 'Въведете пълно име',
		'emailPlaceholder': 'Въведете имейл адрес',
		'invalidEmailText': 'Моля, въведете валиден имейл адрес',
	},
	'CS': {
		'nameLabel': 'Jméno',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Zadejte celé jméno',
		'emailPlaceholder': 'Zadejte e-mailovou adresu',
		'invalidEmailText': 'Zadejte prosím platnou e-mailovou adresu',
	},
	'DA': {
		'nameLabel': 'Navn',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Indtast fulde navn',
		'emailPlaceholder': 'Indtast e-mailadresse',
		'invalidEmailText': 'Indtast venligst en gyldig e-mailadresse',
	},
	'ES': {
		'nameLabel': 'Nombre',
		'emailLabel': 'Correo electrónico',
		'phoneLabel': 'Teléfono',
		'namePlaceholder': 'Ingrese el nombre completo',
		'emailPlaceholder': 'Ingrese la dirección de correo electrónico',
		'invalidEmailText': 'Por favor ingrese una dirección de correo electrónico válida',
	},
	'FI': {
		'nameLabel': 'Nimi',
		'emailLabel': 'Sähköposti',
		'phoneLabel': 'Puhelin',
		'namePlaceholder': 'Anna koko nimi',
		'emailPlaceholder': 'Anna sähköpostiosoite',
		'invalidEmailText': 'Anna kelvollinen sähköpostiosoite',
	},
	'HR': {
		'nameLabel': 'Ime',
		'emailLabel': 'E-pošta',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Unesite puno ime',
		'emailPlaceholder': 'Unesite adresu e-pošte',
		'invalidEmailText': 'Molimo unesite valjanu adresu e-pošte',
	},
	'HU': {
		'nameLabel': 'Név',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Adja meg a teljes nevet',
		'emailPlaceholder': 'Adja meg az e-mail címet',
		'invalidEmailText': 'Kérjük, adjon meg egy érvényes e-mail címet',
	},
	'IT': {
		'nameLabel': 'Nome',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefono',
		'namePlaceholder': 'Inserisci il nome completo',
		'emailPlaceholder': 'Inserisci l\'indirizzo e-mail',
		'invalidEmailText': 'Si prega di inserire un indirizzo e-mail valido',
	},
	'NO': {
		'nameLabel': 'Navn',
		'emailLabel': 'E-post',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Skriv inn fullt navn',
		'emailPlaceholder': 'Skriv inn e-postadresse',
		'invalidEmailText': 'Vennligst skriv inn en gyldig e-postadresse',
	},
	'PT': {
		'nameLabel': 'Nome',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefone',
		'namePlaceholder': 'Insira o nome completo',
		'emailPlaceholder': 'Insira o endereço de e-mail',
		'invalidEmailText': 'Por favor, insira um endereço de e-mail válido',
	},
	'RO': {
		'nameLabel': 'Nume',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Introduceți numele complet',
		'emailPlaceholder': 'Introduceți adresa de e-mail',
		'invalidEmailText': 'Vă rugăm să introduceți o adresă de e-mail validă',
	},
	'RU': {
		'nameLabel': 'Имя',
		'emailLabel': 'Электронная почта',
		'phoneLabel': 'Телефон',
		'namePlaceholder': 'Введите полное имя',
		'emailPlaceholder': 'Введите адрес электронной почты',
		'invalidEmailText': 'Пожалуйста, введите действительный адрес электронной почты',
	},
	'SK': {
		'nameLabel': 'Meno',
		'emailLabel': 'E-mail',
		'phoneLabel': 'Telefón',
		'namePlaceholder': 'Zadajte celé meno',
		'emailPlaceholder': 'Zadajte e-mailovú adresu',
		'invalidEmailText': 'Zadajte prosím platnú e-mailovú adresu',
	},
	'SI': {
		'nameLabel': 'Ime',
		'emailLabel': 'E-pošta',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Vnesite polno ime',
		'emailPlaceholder': 'Vnesite e-poštni naslov',
		'invalidEmailText': 'Prosimo, vnesite veljaven e-poštni naslov',
	},
	'SV': {
		'nameLabel': 'Namn',
		'emailLabel': 'E-post',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Ange fullständigt namn',
		'emailPlaceholder': 'Ange e-postadress',
		'invalidEmailText': 'Vänligen ange en giltig e-postadress',
	},
	'TR': {
		'nameLabel': 'İsim',
		'emailLabel': 'E-posta',
		'phoneLabel': 'Telefon',
		'namePlaceholder': 'Tam adı girin',
		'emailPlaceholder': 'E-posta adresini girin',
		'invalidEmailText': 'Lütfen geçerli bir e-posta adresi girin',
	},
	'UK': {
		'nameLabel': 'Ім\'я',
		'emailLabel': 'Електронна пошта',
		'phoneLabel': 'Телефон',
		'namePlaceholder': 'Введіть повне ім\'я',
		'emailPlaceholder': 'Введіть адресу електронної пошти',
		'invalidEmailText': 'Будь ласка, введіть дійсну адресу електронної пошти',
	},
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
